<template>
  <div class="cart-wrap cart-wrap-checkout">
    <div class="row">
      <div class="col-12">
        <div class="cart-wrap-col">
          <div class="cart-wrap-col-inner">
            <div class="basket-lines basket-lines-header">
              <div class="line-col line-name">Paslauga</div>
              <!--              <div class="line-col line-qty">
                Kiekis
              </div>
              <div class="line-col line-price">
                Kaina
              </div>-->
              <div class="line-col line-total">Kaina</div>
            </div>
            <div
              v-for="(line, i) in basket.lines"
              :key="i"
              class="basket-lines"
            >
              <div class="line-col line-name">
                <span class="text-strong">{{ line.name }}</span>
              </div>
              <!--              <div class="line-col line-qty">
                <div class="res_only_basket">Kiekis:</div>
                <div class="res_only_value">{{ line.qty_items }}</div>
              </div>-->
              <!--              <div class="line-col line-price">
                <div class="res_only_basket">Vnt. kaina:</div>
                <div class="res_only_value">{{ line.price / 100 }} €</div>
              </div>-->
              <div class="line-col line-total">
                <div class="res_only_basket">Kaina:</div>
                <div class="res_only_value">{{ line.line_total / 100 }} €</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    basket() {
      return this.$store.state.basket
    },
  },
}
</script>
